// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/chef-root-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TcRmhxGOmiYnlwma {
  margin-top: 97px;
  min-height: calc(100vh - 97px);
  padding-bottom: 96px;
  background-color: #f2efea;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
}

.TcRmhxGOmiYnlwma.teyG0uf66Qj8idCq {
  margin-top: 97px;
  padding-top: 23px;
  background-image: none;
}

.UYBy8ljPKU8B5sIL {
  padding-top: 73px;
  position: relative;
  margin: 0 auto;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1);
}

.UYBy8ljPKU8B5sIL h1 {
  font-size: 24px;
  color: #303030;
  margin-bottom: 16px;
  font-weight: 600;
  line-height: 130%;
  letter-spacing: 0;
  text-align: center;
}

.UYBy8ljPKU8B5sIL h1 + div {
  font-size: 18px;
  font-weight: 200;
  margin-bottom: 47px;
}

.teyG0uf66Qj8idCq .UYBy8ljPKU8B5sIL {
  margin: 0 auto 37px 127px;
  padding: 0;
  width: clamp(90%, 55vw, 1105px);
  max-width: 1105px;
  height: 40px;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  gap: 230px;
}

.teyG0uf66Qj8idCq .UYBy8ljPKU8B5sIL .bf24PeaBJhs7fuI7 {
  margin-top: 46px;
}

.bf24PeaBJhs7fuI7 {
  margin-bottom: 72px;
  width: 868px;
}

.xPHeWW4r8i4Wy9d4 {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.UYBy8ljPKU8B5sIL,
.xPHeWW4r8i4Wy9d4,
.L5VhlsZQFQ4TttVW {
  width: clamp(90%, 55vw, 1105px);
  max-width: 1105px;
}

.xPHeWW4r8i4Wy9d4 .Xknak8wy3jQ729_i {
  width: 40%;
  height: 300px;
  position: relative;
}

.xPHeWW4r8i4Wy9d4 .FCWP6HXbmQWDSd_n {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.xPHeWW4r8i4Wy9d4 .FCWP6HXbmQWDSd_n p {
  font-size: 18px;
  font-weight: 300;
  font-style: italic;
  text-align: left;
  line-height: 128%;
  color: #303030;
  margin: 0;
}

.xPHeWW4r8i4Wy9d4 .FCWP6HXbmQWDSd_n .OMe4rKMhXbEMdQA_ {
  color: #d74a2c;
  font-weight: 500;
  font-size: 18px;
  font-style: italic;
  text-align: left;
  line-height: 128%;
}

.xPHeWW4r8i4Wy9d4 .el70hdGKUNdYFV_W img {
  width: 300px;
}

.teyG0uf66Qj8idCq .bf24PeaBJhs7fuI7 {
  width: 250px;
}

.bf24PeaBJhs7fuI7 .p-dropdown-trigger {
  margin-right: 10px;
}

.bf24PeaBJhs7fuI7 .p-dropdown {
  width: 100% !important;
  text-align: left;
  height: 66px;
  border-radius: 24px;
  box-shadow: 2px 2px 10px 0px #0000000d;
  border: none;
}

.teyG0uf66Qj8idCq .bf24PeaBJhs7fuI7 .p-dropdown {
  height: 38px;
  border-radius: 16px;
}

.bf24PeaBJhs7fuI7 .p-dropdown-label {
  display: block;
  padding: 22px 33px;
  font-size: 20px;
  font-family: "Roboto";
}

.bf24PeaBJhs7fuI7 .p-dropdown-label.p-placeholder {
  padding: 22px 33px;
  font-size: 20px;
  color: #a4a4a4;
}

.JWJoeau1l0HFo0az {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 34px;
}

.JWJoeau1l0HFo0az .p-dropdown-items-wrapper {
  max-height: 400px !important;
}

.teyG0uf66Qj8idCq.JWJoeau1l0HFo0az {
  border-radius: 16px;
  padding: 3px;
  width: 250px;
}

.JWJoeau1l0HFo0az .p-dropdown-items li {
  height: 57px;
  border-radius: 15px;
  margin: 4px 0px;
  font-size: 21px;
  color: #303030;
}

.teyG0uf66Qj8idCq.JWJoeau1l0HFo0az .p-dropdown-items li {
  height: 38px;
  border-radius: 12px;
  margin: 4px 0px;
  font-size: 14px;
}

.JWJoeau1l0HFo0az .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.teyG0uf66Qj8idCq.JWJoeau1l0HFo0az
  .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 1px solid transparent;
}

.JWJoeau1l0HFo0az
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 2px solid #20336c;
  background-color: inherit;
}

.teyG0uf66Qj8idCq.JWJoeau1l0HFo0az
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 1px solid #20336c;
}

.JWJoeau1l0HFo0az .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  background-color: inherit;
}

.JWJoeau1l0HFo0az .p-dropdown-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.JWJoeau1l0HFo0az .p-dropdown-item.p-highlight:after {
  content: "✓";
  position: absolute;
  right: 16px;
  font-size: 24px;
  color: #ffffff;
}

.teyG0uf66Qj8idCq.JWJoeau1l0HFo0az .p-dropdown-item.p-highlight:after {
  right: 12px;
  font-size: 20px;
}

.teyG0uf66Qj8idCq .bf24PeaBJhs7fuI7 .p-dropdown {
  height: 40px;
  border-radius: 16px;
}

.teyG0uf66Qj8idCq .bf24PeaBJhs7fuI7 .p-dropdown-label {
  display: block;
  padding: 12px 22px;
  font-size: 14px;
  font-family: "Roboto";
}

.L5VhlsZQFQ4TttVW {
  /*width: 1105px;*/
  margin: 0 auto 0 127px;
}

.f5JBfKRGQIUmSFwe {
  margin-top: 20px;
  height: 650px;
}

.f5JBfKRGQIUmSFwe .ks54uhFdsqos8gkv {
  width: 100%;
  height: 100%;
  padding-top: 10px;
}

.f5JBfKRGQIUmSFwe .UNO3nabBk76luTnT {
  font-size: 18px;
  background: #fff;
  border: 1px solid black;
  border-radius: 10px;
  padding: 10px;
  animation-name: y5uWIzFtJcLQqnxS;
  animation-duration: 4s;
  margin-right: 20px;
  flex-shrink: 0;
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.f5JBfKRGQIUmSFwe .UNO3nabBk76luTnT img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes y5uWIzFtJcLQqnxS {
  0% {
    background-color: red;
  }
  100% {
    background-color: transparent;
  }
}

.yqa8XfbgakUwGvi7 {
  width: 60vw;
}

.yqa8XfbgakUwGvi7 .p-orderlist-controls {
  display: none;
}

@media screen and (max-width: 1280px) {
  .TcRmhxGOmiYnlwma {
    margin-top: 65px;
    min-height: calc(100vh - 65px);
  }

  .TcRmhxGOmiYnlwma.teyG0uf66Qj8idCq {
    margin-top: 65px;
  }
}

/* shift page down when offline banner visible */
/* banner overlays header — no layout shift */
body.Rl0D3ulE0UkddXOy .UYBy8ljPKU8B5sIL {
  transform: translateY(28px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chef/ChefPortal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,yBAAyB;EACzB,yDAA4D;EAC5D,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gCAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,gDAAgD;AAChD,6CAA6C;AAC7C;EACE,2BAA2B;AAC7B","sourcesContent":[".pageWrapper {\r\n  margin-top: 97px;\r\n  min-height: calc(100vh - 97px);\r\n  padding-bottom: 96px;\r\n  background-color: #f2efea;\r\n  background-image: url(../../assets/chef-root-background.svg);\r\n  background-repeat: no-repeat;\r\n  background-position: bottom;\r\n  background-size: contain;\r\n}\r\n\r\n.pageWrapper.pageWithStation {\r\n  margin-top: 97px;\r\n  padding-top: 23px;\r\n  background-image: none;\r\n}\r\n\r\n.header {\r\n  padding-top: 73px;\r\n  position: relative;\r\n  margin: 0 auto;\r\n  font-weight: 500;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n\r\n.header h1 {\r\n  font-size: 24px;\r\n  color: #303030;\r\n  margin-bottom: 16px;\r\n  font-weight: 600;\r\n  line-height: 130%;\r\n  letter-spacing: 0;\r\n  text-align: center;\r\n}\r\n\r\n.header h1 + div {\r\n  font-size: 18px;\r\n  font-weight: 200;\r\n  margin-bottom: 47px;\r\n}\r\n\r\n.pageWithStation .header {\r\n  margin: 0 auto 37px 127px;\r\n  padding: 0;\r\n  width: clamp(90%, 55vw, 1105px);\r\n  max-width: 1105px;\r\n  height: 40px;\r\n  flex-direction: row-reverse;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 230px;\r\n}\r\n\r\n.pageWithStation .header .dropDownWrapper {\r\n  margin-top: 46px;\r\n}\r\n\r\n.dropDownWrapper {\r\n  margin-bottom: 72px;\r\n  width: 868px;\r\n}\r\n\r\n.descriptionWrapper {\r\n  margin: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.header,\r\n.descriptionWrapper,\r\n.mainWrapper {\r\n  width: clamp(90%, 55vw, 1105px);\r\n  max-width: 1105px;\r\n}\r\n\r\n.descriptionWrapper .quoteWrapper {\r\n  width: 40%;\r\n  height: 300px;\r\n  position: relative;\r\n}\r\n\r\n.descriptionWrapper .description {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: start;\r\n  justify-content: center;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.descriptionWrapper .description p {\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n  font-style: italic;\r\n  text-align: left;\r\n  line-height: 128%;\r\n  color: #303030;\r\n  margin: 0;\r\n}\r\n\r\n.descriptionWrapper .description .orange {\r\n  color: #d74a2c;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  font-style: italic;\r\n  text-align: left;\r\n  line-height: 128%;\r\n}\r\n\r\n.descriptionWrapper .imageWrapper img {\r\n  width: 300px;\r\n}\r\n\r\n.pageWithStation .dropDownWrapper {\r\n  width: 250px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-trigger) {\r\n  margin-right: 10px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n  width: 100% !important;\r\n  text-align: left;\r\n  height: 66px;\r\n  border-radius: 24px;\r\n  box-shadow: 2px 2px 10px 0px #0000000d;\r\n  border: none;\r\n}\r\n\r\n.pageWithStation .dropDownWrapper :global(.p-dropdown) {\r\n  height: 38px;\r\n  border-radius: 16px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 22px 33px;\r\n  font-size: 20px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label.p-placeholder) {\r\n  padding: 22px 33px;\r\n  font-size: 20px;\r\n  color: #a4a4a4;\r\n}\r\n\r\n.dropDownPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 34px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.pageWithStation.dropDownPanel {\r\n  border-radius: 16px;\r\n  padding: 3px;\r\n  width: 250px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 57px;\r\n  border-radius: 15px;\r\n  margin: 4px 0px;\r\n  font-size: 21px;\r\n  color: #303030;\r\n}\r\n\r\n.pageWithStation.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 38px;\r\n  border-radius: 12px;\r\n  margin: 4px 0px;\r\n  font-size: 14px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.pageWithStation.dropDownPanel\r\n  :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.dropDownPanel\r\n  :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 2px solid #20336c;\r\n  background-color: inherit;\r\n}\r\n\r\n.pageWithStation.dropDownPanel\r\n  :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 1px solid #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  right: 16px;\r\n  font-size: 24px;\r\n  color: #ffffff;\r\n}\r\n\r\n.pageWithStation.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n  right: 12px;\r\n  font-size: 20px;\r\n}\r\n\r\n.pageWithStation .dropDownWrapper :global(.p-dropdown) {\r\n  height: 40px;\r\n  border-radius: 16px;\r\n}\r\n\r\n.pageWithStation .dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 12px 22px;\r\n  font-size: 14px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.mainWrapper {\r\n  /*width: 1105px;*/\r\n  margin: 0 auto 0 127px;\r\n}\r\n\r\n.swiperWrapper {\r\n  margin-top: 20px;\r\n  height: 650px;\r\n}\r\n\r\n.swiperWrapper .mySwiper {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding-top: 10px;\r\n}\r\n\r\n.swiperWrapper .swiperSlide {\r\n  font-size: 18px;\r\n  background: #fff;\r\n  border: 1px solid black;\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n  animation-name: newOrder;\r\n  animation-duration: 4s;\r\n  margin-right: 20px;\r\n  flex-shrink: 0;\r\n  width: 350px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.swiperWrapper .swiperSlide img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n@keyframes newOrder {\r\n  0% {\r\n    background-color: red;\r\n  }\r\n  100% {\r\n    background-color: transparent;\r\n  }\r\n}\r\n\r\n.listWrapper {\r\n  width: 60vw;\r\n}\r\n\r\n.listWrapper :global(.p-orderlist-controls) {\r\n  display: none;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .pageWrapper {\r\n    margin-top: 65px;\r\n    min-height: calc(100vh - 65px);\r\n  }\r\n\r\n  .pageWrapper.pageWithStation {\r\n    margin-top: 65px;\r\n  }\r\n}\r\n\r\n/* shift page down when offline banner visible */\r\n/* banner overlays header — no layout shift */\r\nbody.offline-banner-visible .header {\r\n  transform: translateY(28px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `TcRmhxGOmiYnlwma`;
export var pageWithStation = `teyG0uf66Qj8idCq`;
export var header = `UYBy8ljPKU8B5sIL`;
export var dropDownWrapper = `bf24PeaBJhs7fuI7`;
export var descriptionWrapper = `xPHeWW4r8i4Wy9d4`;
export var mainWrapper = `L5VhlsZQFQ4TttVW`;
export var quoteWrapper = `Xknak8wy3jQ729_i`;
export var description = `FCWP6HXbmQWDSd_n`;
export var orange = `OMe4rKMhXbEMdQA_`;
export var imageWrapper = `el70hdGKUNdYFV_W`;
export var dropDownPanel = `JWJoeau1l0HFo0az`;
export var swiperWrapper = `f5JBfKRGQIUmSFwe`;
export var mySwiper = `ks54uhFdsqos8gkv`;
export var swiperSlide = `UNO3nabBk76luTnT`;
export var newOrder = `y5uWIzFtJcLQqnxS`;
export var listWrapper = `yqa8XfbgakUwGvi7`;
var _1 = `Rl0D3ulE0UkddXOy`;
export { _1 as "offline-banner-visible" };
export default ___CSS_LOADER_EXPORT___;
